export const blockIconsBusinessandpaymentsQueryStatsNew = (
	<span className='material-symbols-outlined'>query_stats</span>
);
